module.exports = __webpack_public_path__ + "static/media/recomendation-medium.ccc6b6b1.svg";